import { saveBaiduExpandData, saveQiHuExpandData, saveSouGouExpandData, saveZhiHuExpandData } from "./expand";

function saveOCPCData() {
    saveBaiduExpandData();
    saveQiHuExpandData();
    saveZhiHuExpandData();
    saveSouGouExpandData();
}

export { saveOCPCData }